import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class AbandonedHutSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.ABANDONED_HUT;
}

export default AbandonedHutSalvageableTileEntity;
